<template slot-scope="scope">
  <!-- 切换行业弹窗 -->
  <dialogModel
    title="添加保险种类"
    :visible.sync="dialogInsurance"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <!-- 主体 -->
    <div class="main-body">
      <div class="right-Options">
        <!-- 右侧市级box -->
        <div class="MunicipalLevel-box">
          <div
            v-for="(item, index) in TypesInsurance"
            :key="item.id"
            :class="item.select == 1 ? 'TheCitySelect' : ''"
            @click="handelTheCitySelect(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 选择回显 -->
    <div class="Select-line">
      <div class="Select-Tips">已选择：</div>
      <div class="echo">
        <div class="data-echo" v-for="(item, index) in echoVal" :key="index">
          <div>{{ item.name }}</div>
          <div class="firm-clickable" @click="handelDelete(item)"></div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
// import Vue from 'vue'
// Vue.use(set);
// 引入接口
import {
  postGetCarSafeType, //获取保险种类
} from "../../../../assets/api/indexl";

export default {
  props: {
    dialogInsurance: {},
    transform: {}, // 监听此值，改变立刻清空选中
  },
  components: {},
  data() {
    return {
      echoVal: [], // 用于回显选中
      echoId: [], // 用于传递参数（回显选中）
      TypesInsurance: [],
    };
  },
  // 监听
  watch: {
    transform: {
      handler(newss, old) {
        console.log(newss, "监听到改变");
        this.echoVal = []; // 用于回显选中
        this.echoId = []; // 用于传递参数（回显选中）
        for (var i in this.TypesInsurance) {
          this.TypesInsurance[i].select = 0;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.postGetCarSafeType();
  },
  mounted() {},
  methods: {
    // ---------------------------获取保险种类-------------------
    async postGetCarSafeType() {
      const res = await postGetCarSafeType();
      if (res.code == 0) {
        for (var i in res.data) {
          res.data[i].select = 0;
        }
        // 保险种类
        this.TypesInsurance = res.data;
      }
    },
    //选择行业
    handelClickMenu(item) {},
    // 选择 职位  下方已选择职位回显点击x取消选中
    handelTheCitySelect(item, index) {
      // 选中样式
      if (item.select == 0) {
        item.select = 1;
        this.echoVal[this.echoVal.length++] = item;
        this.echoId[this.echoId.length++] = item.id;
      } else {
        item.select = 0;
        for (var i in this.echoVal) {
          if (item.name == this.echoVal[i].name) {
            this.echoVal.splice(i, 1);
          }
          if (item.id == this.echoId[i]) {
            this.echoId.splice(i, 1);
          }
        }
      }
    },
    // 点击删除已选择
    handelDelete(item) {
      for (var i in this.echoVal) {
        if (item.name == this.echoVal[i].name) {
          this.echoVal.splice(i, 1);
        }
        if (item.id == this.echoId[i]) {
          this.echoId.splice(i, 1);
        }
      }
      for (var k in this.TypesInsurance) {
        if (item.id == this.TypesInsurance[k].id) {
          this.TypesInsurance[k].select = 0;
        }
      }
    },

    // 弹窗关闭
    handleClose() {
      // this.echoVal = []; // 用于回显选中
      // this.echoId = []; // 用于传递参数（回显选中）
      // for (var i in this.TypesInsurance) {
      //   this.TypesInsurance[i].select = 0;
      // }
      this.$emit("handleClose");
      //   this.dialogVisible = false;
    },
    // 弹窗确认
    handleUnderstand() {
      this.$emit("handleUnderstand", this.echoVal, this.echoId);
    },
  },
};
</script>

<style scoped lang="less">
// 标题
.title {
  width: 100%;
  height: 90px;
  position: relative;
  display: flex;
  // 关闭按钮
  .Off-icon {
    width: 18px;
    height: 18px;
    background-image: url("../../../../assets/imgs/guanbi.svg");
    background-size: 100% 100%;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .Text-title {
    height: 20px;
    width: 100px;
    line-height: 20px;
    margin: auto 0;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    margin-left: 30px;
  }
  // 搜索框
  .input-box {
    width: 340px;
    height: 30px;
    line-height: 30px;
    margin: auto 0;
    margin-left: 70px;
    display: flex;
    position: relative;
    // input框的样式
    /deep/.el-input__inner {
      width: 250px;
      font-size: 16px;
      line-height: 30px;
      height: 30px !important;
      border: 1px solid #409eff ;
      background: #ffffff;
      position: absolute;
      border-radius: 10px;
      z-index: 1;
    }
    // 搜索按钮样式
    .search_btn {
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
      line-height: 30px;
      background-color: #409eff ;
      width: 100px;
      height: 30px;
      border-radius: 0px 10px 10px 0px;
      cursor: pointer;
      position: absolute;
      right: 0;
      display: flex;
      white-space: nowrap;
      div {
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        p {
          width: 20px;
          height: 20px;
          background-image: url("../../../../assets/imgs/sousuo@3x.svg");
          background-size: 100% 100%;
          margin-right: 3px;
        }
      }
    }
  }
}
// 内容主体
.main-body {
  width: 100%;
  height: 300px;
  display: flex;
  border-bottom: 1px dashed #409eff ;
  .left-menu::-webkit-scrollbar {
    display: none;
  }
  .left-menu {
    width: 175px;
    height: 100%;
    margin-left: 5px;
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    div {
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px 0px 0px 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
    }
    .left-menu-Select {
      background: #eeeeee;
      color: #409eff ;
    }
  }
  .right-Options {
    flex: 1;
    height: 100%;
    background: #eeeeee;
    // 市级 div
    .MunicipalLevel-box {
      margin: 20px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      div {
        padding-left: 5px;
        padding-right: 5px;
        min-width: 85px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 18px;
        margin-bottom: 18px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        cursor: pointer;
      }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
  }
}
// 回显选中的行业
.Select-line {
  width: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  .Select-Tips {
    height: 16px;
    line-height: 16px;
    margin-left: 30px;
    margin-top: 15px;
  }
  .echo {
    min-height: 30px;
    line-height: 30px;
    margin-top: 10px;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    .data-echo {
      padding-left: 5px;
      padding-right: 5px;
      min-width: 85px;
      height: 30px;
      background: #409eff ;
      border: 1px solid #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin-right: 20px;
      display: flex;
      position: relative;
      margin-bottom: 10px;
      div {
        min-width: 85px;
        height: 30px;
        margin: auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      div {
        width: 18px;
        height: 18px;
        position: absolute;
        right: -8px;
        top: -8px;
        background-image: url("../../../../assets/imgs/guanbi@3x.svg");
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
}

// 调整对话框
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
